export enum ReachedLimitsUrls {
  Loss = 'loss',
  Playtime = 'playtime',
}

export enum ReachedLimitTypes {
  Loss = 'Loss',
  Time = 'Time',
}

export enum ReachedLimitPeriods {
  Daily = 'Daily',
  Weekly = 'Weekly',
  Monthly = 'Monthly',
}

export type LimitReachedSocketData = {
  type: ReachedLimitTypes;
  period: ReachedLimitPeriods;
  resetDate: string;
  amount: number;
};

export type LimitReachedBottomSheetProps = {
  type: ReachedLimitTypes;
  period: ReachedLimitPeriods;
  resetDate: string;
};
